import { render, staticRenderFns } from "./DIASRealEstatePledgesNotTransferred.vue?vue&type=template&id=41243b05&"
import script from "./DIASRealEstatePledgesNotTransferred.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstatePledgesNotTransferred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports